// dom元素观测类
export default class VisibleObserver {
    constructor() {
        // dom元素map存储
        this._observeMap = new WeakMap();
        // 被观测视口信息存储
        this._listMap = new Map();
    }
    // 构建观测实例
    createObserver(list) {
        const {
            // 触发监听的时机，卡片的比例
            threshold = [0, 0.5, 1],
            // 设置触发 margin
            rootMargin = '0px 0px'
        } = {};
        let params = {
            threshold,
            rootMargin
        };
        if (list) {
            params.root = list;
        }
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entrie => {
                    this.handleShow(entrie, observer);
                });
            },
            params
        );

        return observer;
    }
    // 卡片触发监听的回调
    handleShow(entrie, observer) {
        // dom元素
        const el = entrie.target;
        if (!el) {
            return;
        }
        let data = null;
        // 未露出视口
        if (entrie.intersectionRatio <= 0) {
            return;
        }
        // 监听到卡片出现大于自身的0.5之后赋值data，然后触发dispatchEvent事件
        if (entrie.intersectionRatio >= 0.5) {
            data = {
                ratio: entrie.intersectionRatio,
                visible: true
            };
            // 销毁监听
            observer.unobserve(el);
            // 移除监听
            this._observeMap.delete(el);
        }

        if (data) {
            // 触发自定义事件
            const event = new CustomEvent('domVisibleChange', {
                detail: data,
                propagation: false,
                bubbles: false
            });
            el.dispatchEvent(event);
        }
    }
    // 观测dom元素
    observe(el, listId) {
        if (!el) {
            return;
        }

        // 如果map中有当前节点了
        if (this._observeMap.has(el)) {
            return;
        }
        // 没有节点时候设置当前数据
        const listData = this._listMap.get(listId);
        if (!listData) {
            return;
        }

        // 如果不存在监听，设置监听
        if (!listData.observer) {
            listData.observer = this.createObserver(listData.list);
        }

        this._observeMap.set(el, {
            isIntersecting: false
        });
        listData.observer.observe(el);
    }

    // 往list_map中添加
    addList(list, id) {
        const data = {
            id,
            list
        };
        this._listMap.set(id, data);
    }
}